<template>
  <div class="container">
    <div class="row">
      <div class="col-12 mt-4">
        <h3>Please Enter user name and password to login</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <h3>(For Existing Users)</h3>
      </div>
    </div>

    <div class="row ">
      <div class="col-12 text-center">
        <span>
          <input type="text" v-model="userName" placeholder="Enter Username" />
        </span>
      </div>
    </div>

    <div class="row mt-4 mb-4">
      <div class="col-12 text-center">
        <span>
          <input type="password" v-model="password" placeholder="Enter Password" />
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-center">
        <span>
          <button class="btn btn-primary" @click="login">Login</button>
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-center h3 text-danger">
        <span>
          {{loginResult}}
        </span>
      </div>
    </div>
  </div>

   <div class="h1 text-center fw-bold">
    <img
      v-if="companyIconFileName && companyIconFileName !== ''"
      :src="companyIconFileName"
      class="d-inline-block align-text-bottom"
      border-color="red"
      width="65"
      height="65"
    /> 
    {{ companyName }}
  </div>
</template>

<script lang="ts">
import { computed, ref, onMounted } from "vue";
import router from "../router";

export default {
  props: ["baseUrl"],
  setup(props: any) {
    const userName = ref("");
    const password = ref("");
    const loginResult = ref("");
    const baseUrlAddress = computed(() => {
      return `${props.baseUrl}`;
    });
    const registrationUrl = "/#/register";

    const isLoginAuthorized = ref(true);
    const isLogginSuccessfull = ref(false);

    const companyName = ref("");
    const companyIconFileName = ref("");

    onMounted(() => {
      loadBranding();
    });

    const fetchLookupData = async (token: string) => {
      try {
        const response = await fetch(baseUrlAddress.value + "appData/GetAllLookupData", {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch lookup data: ${response.status}`);
        }

        const data = await response.json();
        localStorage.setItem("lookupData", JSON.stringify(data));
      } catch (error) {
        console.error("Failed to fetch lookup data:", error);
      }
    };

    const loadBranding = async () => {
      try {
        const tenantId = window.location.hostname.split('.')[0].toUpperCase();
        const requestUrl = (window as any).VUE_APP_API_KEY + "Login/Settings";
        
        const response = await fetch(requestUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Tenant-ID': tenantId
          }
        });
        
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        
        const branding = await response.json();

        (window as any).SITE_TITLE = branding.branding.companyName;
        (window as any).COMPANY_NAME = branding.branding.companyName;
        (window as any).COMPANY_NAME_FOR_HEADER = branding.branding.companyName;
        (window as any).ICON_FILE = branding.faviconFile;
        (window as any).WHATSAPP_NUMBER = branding.branding.mobileNo;

        localStorage.setItem("companyNameForHeader", branding.branding.companyName);
        localStorage.setItem("companyIconFile", branding.faviconFile);
        
        window.dispatchEvent(new Event('brandingLoaded'));

        companyName.value = branding.branding.companyName;
        companyIconFileName.value = branding.faviconFile;

        document.title = branding.branding.companyName;
        
      } catch (error) {
        console.error("Failed to load branding:", error);
      }

      companyName.value = localStorage.getItem("companyNameForHeader") || "";
      companyIconFileName.value = localStorage.getItem("companyIconFile") || "";
    };

    const login = async () => {
      loginResult.value = "";
      const requestUrl = baseUrlAddress.value + "Login/AdminLoginForTokenNew";

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          UserId: 0,
          UserName: userName.value,
          Password: password.value,
        }),
      };

      try {
        const response = await fetch(requestUrl, requestOptions);

        if (response.status === 400 || response.status === 401 || response.status === 404) {
          localStorage.setItem("token", "");
          isLoginAuthorized.value = false;
          isLogginSuccessfull.value = false;
          loginResult.value = "Could not login please try again.";
          return;
        }

        const res = await response.json().catch(() => null);
        const userVm = res?.loginResultUserViewModel ?? res?.userViewModel ?? res;

        if (userVm && (userVm.token != null && userVm.token !== "")) {
          // Store token
          localStorage.setItem("token", String(userVm.token));
          if (userVm.id != null) localStorage.setItem("userId", String(userVm.id));
          if (userVm.officerId != null) localStorage.setItem("OfficerId", String(userVm.officerId));
          if (res?.officerName) localStorage.setItem("officerName", String(res.officerName));

          // Fetch lookup data
          await fetchLookupData(userVm.token);

          isLoginAuthorized.value = true;
          isLogginSuccessfull.value = true;
          
          // 🔥🔥🔥 IMPORTANT: Dispatch event to update navbar 🔥🔥🔥
          window.dispatchEvent(new Event('login-status-changed'));
          
          // Also update the flag
          localStorage.setItem("isLogginSuccessfull", "true");
          
          // Redirect
          router.push("expirydatesscan");
        } else {
          localStorage.setItem("token", "");
          isLoginAuthorized.value = false;
          isLogginSuccessfull.value = false;
          loginResult.value = "Invalid username or password.";
        }

        localStorage.setItem("isLogginSuccessfull", String(isLogginSuccessfull.value));
      } catch (error) {
        console.error("Login error:", error);
        loginResult.value = "Error Occurred and could not login please try again.";
        localStorage.setItem("token", "");
        isLoginAuthorized.value = false;
        isLogginSuccessfull.value = false;
      }
    };

    return {
      userName,
      password,
      login,
      baseUrlAddress,
      loginResult,
      registrationUrl,
      companyName,
      companyIconFileName,
      loadBranding,
    };
  },
};
</script>

<style></style>